import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_CreateNoteHoverLabel.scss';
export const Label_CreateNote = 'Create Note';
export const Component_CreateNoteHoverLabel = ({ resting }) => {
    return _jsxs("span", { className: 'create-note-hover', children: [_jsx("span", { className: 'create-note-hover__resting', children: resting }), _jsx("span", { className: 'create-note-hover__active', "aria-hidden": 'true', children: Label_CreateNote })] });
};
//# sourceMappingURL=Component_CreateNoteHoverLabel.js.map